import { Image } from 'app/shared/ui';

import { InsuranceHubHeaderTickWrapperSt } from '../../InsuranceHubHeader/InsuranceHubHeader.css';

import { TInformationItem } from './types';
import * as Styled from './index.css';

export const InformationItem = ({ message }: TInformationItem): JSX.Element => {
  return (
    <InsuranceHubHeaderTickWrapperSt>
      <Image
        src="/assets/insuranceHub/insurancehub-tick.svg"
        width={24}
        height={21.58}
        alt={message}
        mb="10px"
      />
      <Styled.InformationItemText
        fontSize="16px"
        lineHeight="26px"
        fontWeight="500"
        ml="12px"
      >
        {message}
      </Styled.InformationItemText>
    </InsuranceHubHeaderTickWrapperSt>
  );
};
